import { render } from "./AdminAsignatura.vue?vue&type=template&id=7fa1115e&scoped=true"
import script from "./AdminAsignatura.vue?vue&type=script&lang=js"
export * from "./AdminAsignatura.vue?vue&type=script&lang=js"

import "./AdminAsignatura.vue?vue&type=style&index=0&id=7fa1115e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa1115e"]])

export default __exports__